import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProcessedMediaCustomizations from './processed-media-customizations-model'
import {
  CreateProcessedMediaCustomizationsAsync,
  DeleteProcessedMediaCustomizationsAsync,
  LoadProcessedMediaCustomizationssAsync,
} from './processedMediaCustomizations-thunk'
const initialState: processedMediaCustomizationsSliceState = {
  processedMediaCustomizations: [],
  selected_processedMediaCustomizations: '',
  is_loading_processedMediaCustomizations: false,
  is_creating_processedMediaCustomizations: false,
  is_deleting_processedMediaCustomizations: false,
}
export interface processedMediaCustomizationsSliceState {
  processedMediaCustomizations: ProcessedMediaCustomizations[]
  selected_processedMediaCustomizations?: string
  is_loading_processedMediaCustomizations: boolean
  is_creating_processedMediaCustomizations: boolean
  is_deleting_processedMediaCustomizations: boolean
}
export const processedMediaCustomizationsSlice = createSlice({
  name: 'processedMediaCustomizations',
  initialState,
  reducers: {
    setSelectedprocessedMediaCustomizations: (state, action) => {
      state.selected_processedMediaCustomizations = action.payload
    },
    clearStateprocessedMediaCustomizations: (state) => {
      state.processedMediaCustomizations = []
      state.is_loading_processedMediaCustomizations = false
      state.is_creating_processedMediaCustomizations = false
      state.is_deleting_processedMediaCustomizations = false
    },
    mergeprocessedMediaCustomizations: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_processedMediaCustomizations = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.processedMediaCustomizations = merge(
            state.processedMediaCustomizations,
            payload,
          ) as any
        }
      }
    },

    add_processedMediaCustomizations: (state, action) => {
      if (action.payload) {
        state.processedMediaCustomizations = [
          ...state.processedMediaCustomizations,
          action.payload,
        ]
      }
    },
    set_processedMediaCustomizations: (state, action) => {
      let { key, value, id } = action.payload
      state.processedMediaCustomizations =
        state.processedMediaCustomizations.map((item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProcessedMediaCustomizationssAsync.pending, (state) => {
      state.is_loading_processedMediaCustomizations = true
    })
    builder.addCase(
      LoadProcessedMediaCustomizationssAsync.fulfilled,
      (state, action) => {
        state.is_loading_processedMediaCustomizations = false
        if (action.payload) {
          state.processedMediaCustomizations = action.payload
        }
      },
    )
    builder.addCase(
      LoadProcessedMediaCustomizationssAsync.rejected,
      (state) => {
        state.is_loading_processedMediaCustomizations = false
      },
    )
    builder.addCase(
      CreateProcessedMediaCustomizationsAsync.pending,
      (state) => {
        state.is_creating_processedMediaCustomizations = true
      },
    )
    builder.addCase(
      CreateProcessedMediaCustomizationsAsync.fulfilled,
      (state) => {
        state.is_creating_processedMediaCustomizations = false
      },
    )
    builder.addCase(
      CreateProcessedMediaCustomizationsAsync.rejected,
      (state) => {
        state.is_creating_processedMediaCustomizations = false
      },
    )
    builder.addCase(
      DeleteProcessedMediaCustomizationsAsync.pending,
      (state) => {
        state.is_deleting_processedMediaCustomizations = true
      },
    )
    builder.addCase(
      DeleteProcessedMediaCustomizationsAsync.fulfilled,
      (state, action) => {
        state.is_deleting_processedMediaCustomizations = false
        if (state.processedMediaCustomizations) {
          state.processedMediaCustomizations =
            state.processedMediaCustomizations.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(
      DeleteProcessedMediaCustomizationsAsync.rejected,
      (state) => {
        state.is_deleting_processedMediaCustomizations = false
      },
    )
  },
})

export const {
  clearStateprocessedMediaCustomizations,
  setSelectedprocessedMediaCustomizations,
  set_processedMediaCustomizations,
  mergeprocessedMediaCustomizations,
  add_processedMediaCustomizations,
} = processedMediaCustomizationsSlice.actions

export const get_processedMediaCustomizations =
  (id?: string) =>
  (state: {
    processedMediaCustomizations: {
      processedMediaCustomizations: ProcessedMediaCustomizations[]
    }
  }): ProcessedMediaCustomizations | null => {
    let temp =
      state?.processedMediaCustomizations?.processedMediaCustomizations?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.processedMediaCustomizations?.processedMediaCustomizations[0] ||
      null
    )
  }
export const get_selected_processedMediaCustomizations = (state: {
  processedMediaCustomizations: processedMediaCustomizationsSliceState
}): ProcessedMediaCustomizations | null => {
  let id =
    state?.processedMediaCustomizations?.selected_processedMediaCustomizations
  let temp =
    state?.processedMediaCustomizations?.processedMediaCustomizations?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_processedMediaCustomizations = (state: {
  processedMediaCustomizations: {
    processedMediaCustomizations: ProcessedMediaCustomizations[]
  }
}): ProcessedMediaCustomizations[] => {
  let temp = state?.processedMediaCustomizations?.processedMediaCustomizations
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_processedMediaCustomizations_busy = (state: {
  processedMediaCustomizations: processedMediaCustomizationsSliceState
}) => {
  return (
    state?.processedMediaCustomizations
      .is_deleting_processedMediaCustomizations ||
    state?.processedMediaCustomizations
      .is_loading_processedMediaCustomizations ||
    state?.processedMediaCustomizations.is_creating_processedMediaCustomizations
  )
}
export const is_deleting_processedMediaCustomizations_busy = (state: {
  processedMediaCustomizations: processedMediaCustomizationsSliceState
}) => {
  return state?.processedMediaCustomizations
    .is_deleting_processedMediaCustomizations
}
export const is_loading_processedMediaCustomizations_busy = (state: {
  processedMediaCustomizations: processedMediaCustomizationsSliceState
}) => {
  return state?.processedMediaCustomizations
    .is_loading_processedMediaCustomizations
}
export const is_creating_processedMediaCustomizations_busy = (state: {
  processedMediaCustomizations: processedMediaCustomizationsSliceState
}) => {
  return state?.processedMediaCustomizations
    .is_creating_processedMediaCustomizations
}

export default processedMediaCustomizationsSlice.reducer
